import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  id: "marketTable",
  width: "100%",
  align: "center",
  cellpadding: "0",
  cellspacing: "0",
  style: {
    "border-collapse": "collapse",
    "border": "none"
  },
  bordercolor: "#BCBCBC"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", {
  class: "head_bg"
}, [/*#__PURE__*/_createElementVNode("th", null, "单号"), /*#__PURE__*/_createElementVNode("th", null, "类型"), /*#__PURE__*/_createElementVNode("th", null, "公司"), /*#__PURE__*/_createElementVNode("th", null, "申请人"), /*#__PURE__*/_createElementVNode("th", null, "申请时间"), /*#__PURE__*/_createElementVNode("th", null, "签章")])], -1);
const _hoisted_3 = {
  align: "center"
};
const _hoisted_4 = {
  align: "center"
};
const _hoisted_5 = {
  align: "center"
};
const _hoisted_6 = {
  align: "center"
};
const _hoisted_7 = {
  align: "center"
};
const _hoisted_8 = {
  align: "center"
};
const _hoisted_9 = {
  key: 0,
  style: {
    "font-size": "12px",
    "text-align": "center",
    "margin": "20px"
  }
};
const _hoisted_10 = {
  id: "marketTable",
  width: "100%",
  align: "center",
  cellpadding: "0",
  cellspacing: "0",
  style: {
    "border-collapse": "collapse",
    "border": "none"
  },
  bordercolor: "#BCBCBC"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", {
  class: "head_bg"
}, [/*#__PURE__*/_createElementVNode("th", null, "单号"), /*#__PURE__*/_createElementVNode("th", null, "类型"), /*#__PURE__*/_createElementVNode("th", null, "公司"), /*#__PURE__*/_createElementVNode("th", null, "申请人"), /*#__PURE__*/_createElementVNode("th", null, "申请时间"), /*#__PURE__*/_createElementVNode("th", null, "签章")])], -1);
const _hoisted_12 = {
  align: "center"
};
const _hoisted_13 = {
  align: "center"
};
const _hoisted_14 = {
  align: "center"
};
const _hoisted_15 = {
  align: "center"
};
const _hoisted_16 = {
  align: "center"
};
const _hoisted_17 = {
  align: "center"
};
const _hoisted_18 = {
  key: 0,
  style: {
    "font-size": "12px",
    "text-align": "center",
    "margin": "20px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "签章列表"
  }), _createVNode(_component_van_tabs, {
    modelValue: $data.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.active = $event),
    onClickTab: $options.onClickTab
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "未处理"
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("table", _hoisted_1, [_hoisted_2, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collectionlist, (item, index) => {
        return _openBlock(), _createElementBlock("tr", {
          id: "ctr1",
          class: "bottom-bor",
          key: index
        }, [_createElementVNode("td", _hoisted_3, _toDisplayString(item.SellBillNumber), 1), _createElementVNode("td", _hoisted_4, _toDisplayString(item.type), 1), _createElementVNode("td", _hoisted_5, _toDisplayString(item.types), 1), _createElementVNode("td", _hoisted_6, _toDisplayString(item.applicant), 1), _createElementVNode("td", _hoisted_7, _toDisplayString(item.created_at), 1), _createElementVNode("td", _hoisted_8, [_createVNode(_component_van_button, {
          type: "primary",
          size: "mini",
          onClick: $event => $options.exportReportsale(index, 1)
        }, {
          default: _withCtx(() => [_createTextVNode("签章")]),
          _: 2
        }, 1032, ["onClick"])])]);
      }), 128))])]), $data.isshow ? (_openBlock(), _createElementBlock("div", _hoisted_9, "您没有权限查看")) : _createCommentVNode("", true)])]),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: "已处理"
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("table", _hoisted_10, [_hoisted_11, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collectionlist, (item, index) => {
        return _openBlock(), _createElementBlock("tr", {
          id: "ctr1",
          class: "bottom-bor",
          key: index
        }, [_createElementVNode("td", _hoisted_12, _toDisplayString(item.SellBillNumber), 1), _createElementVNode("td", _hoisted_13, _toDisplayString(item.type), 1), _createElementVNode("td", _hoisted_14, _toDisplayString(item.types), 1), _createElementVNode("td", _hoisted_15, _toDisplayString(item.applicant), 1), _createElementVNode("td", _hoisted_16, _toDisplayString(item.created_at), 1), _createElementVNode("td", _hoisted_17, [_createVNode(_component_van_button, {
          type: "success",
          size: "mini",
          onClick: $event => $options.exportReportsale(index, 2)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 2
        }, 1032, ["onClick"])])]);
      }), 128))])]), $data.isshow ? (_openBlock(), _createElementBlock("div", _hoisted_18, "您没有权限查看")) : _createCommentVNode("", true)])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "onClickTab"])]);
}